import React, { Component} from 'react';

interface indicatorProps {
  indicatorValue: number;
  name: string;
  kind: string;
}

const Indicator = (props: indicatorProps) => {

  let curVal = props.indicatorValue || 0;
  let maxVal = props.kind === 'haircheck' ? 4 : 10;
  var tiles = [];

  for( let i = 0 ; i < curVal; i++){
    if (i < Math.max(maxVal, 6)) {
      tiles.push(<div className="indicator-tile bg-green" key={props.name + '-' + i}></div>);
    } else if (i < 8) {
      tiles.push(<div className="indicator-tile bg-orange" key={props.name + '-' + i}></div>);
    } else {
      tiles.push(<div className="indicator-tile bg-red" key={props.name + '-' + i}></div>);
    }
  }
  for( let i = curVal ; i < maxVal ; i++){
      tiles.push(<div className={"indicator-tile " + (props.kind === 'haircheck' ? "bg-white" : "")} key={props.name + '-' + i}></div>);
  }

  return(
      <div className={"indicator-bar " + (props.kind ? "indicator-bar-" + props.kind : "")}>
          {tiles}
      </div>
  )
}

export default Indicator;
